export enum SpecialParentType {
    TABLE_CELL = "tableCell",
    TABLE_HEADER_TOOLS_PANEL = "tableHeaderToolsPanel"
}
